export const EventEmitter = {
  events: {},
  dispatch(event, data) {
    if (!this.events[event]) return
    this.events[event].forEach((callback) => callback(data))
  },
  subscribe(event, callback) {
    if (!this.events[event]) this.events[event] = []
    this.events[event].push(callback)
  },
  unsubscribe(event) {
    if (!this.events[event]) return
    delete this.events[event]
  },
}

export const EVENT_KEY = {
  REFRESH_SCHEDULE: 'REFRESH_SCHEDULE',
  REFRESH_COMPLAINT: 'REFRESH_COMPLAINT',
  REFRESH_BOOKING_DETAIL: 'REFRESH_BOOKING_DETAIL',
  CONVERSATION: 'CONVERSATION',
  CONVERSATION_FOCUS_INPUT: 'CONVERSATION_FOCUS_INPUT',
  SUBMIT_TEST_ONLINE_BOOKING: 'SUBMIT_TEST_ONLINE_BOOKING',
  REFRESH_LEAVE_REQUEST: 'REFRESH_LEAVE_REQUEST',
  REFRESH_BOOKING_HISTORY: 'REFRESH_BOOKING_HISTORY',
  SHOW_CHAT_BUBBLE: 'SHOW_CHAT_BUBBLE',
  ON_CHANGE_CALENDAR: 'ON_CHANGE_CALENDAR',
  RELOAD_CALENDAR: 'RELOAD_CALENDAR',
}
